import React, {useEffect, useState} from 'react';
import moment from 'moment';

import AiBotIcon from '../../../assets/svgComponents/AiBotIcon';
import AutoTextTyperComponent from '../../common/genericComponents/autoTextTyperComponent';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';
import HandoffToAgentBtnComponent from '../handoffToAgentBtnComponent/handoffToAgentBtnComponent';
import ShimmerWithEmptyImageComponent from '../../common/genericComponents/redesign/shimmerWithEmptyImageComponent/shimmerWithEmptyImageComponent';

import chatHandoffService from '../../../services/restServices/chatHandoffService';
import {PrivateRoomService} from '../../../services/websocketService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import '../aiChatMsgContentWrapperComponent/aiChatMsgContentWrapperComponent.css';
import './aiHandoffStartedChatMsgComponent.css';
import NotificationAiBotIcon from '../../../assets/svgComponents/NotificationAiBotIcon';

// const COLD_HANDOFF_ACTIONS_IDS = [
//   VIDABOO_CONSTANTS.HANDOFF_ACTIONS.TEXT_CHAT,
//   VIDABOO_CONSTANTS.HANDOFF_ACTIONS.SCHEDULING,
//   VIDABOO_CONSTANTS.HANDOFF_ACTIONS.CONTACT_FORM,
//   VIDABOO_CONSTANTS.HANDOFF_ACTIONS.WHATSAPP,
//   VIDABOO_CONSTANTS.HANDOFF_ACTIONS.FB_MESSENGER,
//   VIDABOO_CONSTANTS.HANDOFF_ACTIONS.PHONE,
// ];

const HOT_HANDOFF_ACTIONS_IDS = [
  VIDABOO_CONSTANTS.HANDOFF_ACTIONS.VIDEO_CALL,
  VIDABOO_CONSTANTS.HANDOFF_ACTIONS.TEXT_CHAT,
];

const HANDOFF_ACTIONS_BTN_INFO = {
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.SCHEDULING]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.SCHEDULING,
    text: 'Schedule appointment',
    Icon: CommunicationIcons.ScheduleIcon,
  },
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.CONTACT_FORM]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.CONTACT_FORM,
    text: 'Fill a form',
    Icon: CommunicationIcons.FormIcon,
  },
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.VIDEO_CALL]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.VIDEO_CALL,
    text: 'Start video chat',
    Icon: CommunicationIcons.VideoIcon,
  },
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.TEXT_CHAT]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.TEXT_CHAT,
    text: 'Start chat',
    Icon: CommunicationIcons.ChatIcon,
  },
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.PHONE]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.PHONE,
    text: 'Call now',
    Icon: CommunicationIcons.PhoneIcon,
  },
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.WHATSAPP]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.WHATSAPP,
    text: 'WhatsApp',
    Icon: CommunicationIcons.WhatsappIcon,
  },
  [VIDABOO_CONSTANTS.HANDOFF_ACTIONS.FB_MESSENGER]: {
    id: VIDABOO_CONSTANTS.HANDOFF_ACTIONS.FB_MESSENGER,
    text: 'Messenger',
    Icon: CommunicationIcons.MessengerIcon,
  },
};

const AiHandoffStartedChatMsgComponent = ({
  isDemo = false,
  isMentorSide = true,
  chatMessageDto = {},
  chatRoomDto = {},
  chatRowOptionsElement = null,
  lastOoniChatMsg = {},
  mentorDto = {},
  senderObjectId = null,
  senderObjectType = null,
  widgetId = '',
  getTextMessage = () => {},
  onFooterOptionSelected = () => {},
}) => {
  const parsedMetaData = chatMessageDto.parsedMetaData;

  const [chatHandoffFlow, setChatHandoffFlow] = useState(null);
  const [handoffActionsBtnInfo, setHandoffActionsBtnInfo] = useState(null);
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [hotHandoffTimeoutId, setHotHandoffTimeoutId] = useState(null);
  const [chatMsgTime, setChatMsgTime] = useState(null);

  useEffect(() => {
    const msgSendTime = chatMessageDto?.sendTime;
    const chatMsgTime = moment(msgSendTime || undefined).format('D MMMM HH:mm');
    setChatMsgTime(chatMsgTime);
  }, [chatMessageDto?.sendTime]);

  useEffect(() => {
    getHandoffFlow();
  }, []);

  useEffect(() => {
    let removePrivateRoomListener = null;

    const shouldListenToHandoffFlow =
      getShouldListenToHandoffFlowChanges(chatHandoffFlow);

    if (chatRoomDto.roomId && shouldListenToHandoffFlow) {
      removePrivateRoomListener =
        PrivateRoomService.doWhenMessageReceivedFromPrivateRoom(
          chatRoomDto.roomId,
          (data) => {
            if (
              data.messageType ===
                VIDABOO_CONSTANTS.WEBSOCKET_MESSAGE_TYPES.HANDOFF_FLOW &&
              chatHandoffFlow.chatHandoffFlowId ===
                data.content.chatHandoffFlow.chatHandoffFlowId
            ) {
              setChatHandoffFlow(data.content.chatHandoffFlow);
              if (
                !getShouldListenToHandoffFlowChanges(
                  data.content.chatHandoffFlow,
                )
              ) {
                if (removePrivateRoomListener) {
                  removePrivateRoomListener();
                }
              }
            }
          },
        );
    }

    return () => {
      if (removePrivateRoomListener) {
        removePrivateRoomListener();
      }
    };
  }, [chatHandoffFlow?.chatHandoffFlowId]);

  useEffect(() => {
    let handoffActionsBtnInfo = null;
    if (chatHandoffFlow) {
      let selectableHandoffActions = [];
      const showColdHandoffActions = chatHandoffFlow.linkedHotHandoffFlowId;
      if (showColdHandoffActions) {
        // cold handoff message triggered by hot handoff flow
        selectableHandoffActions = chatHandoffFlow.coldHandoffActions;
      } else {
        // hot handoff or cold handoff flow
        selectableHandoffActions = chatHandoffFlow.hotHandoffActions.length
          ? chatHandoffFlow.hotHandoffActions
          : chatHandoffFlow.coldHandoffActions;
      }

      handoffActionsBtnInfo = convertHandoffActionsToBtnFormat(
        selectableHandoffActions,
      );
    }
    setHandoffActionsBtnInfo(handoffActionsBtnInfo);
  }, [chatHandoffFlow?.status]);

  useEffect(() => {
    if (hotHandoffTimeoutId) {
      window.clearTimeout(hotHandoffTimeoutId);
      setHotHandoffTimeoutId(null);
    }

    handleFailureHotHandoff();

    return () => {
      if (hotHandoffTimeoutId) {
        window.clearTimeout(hotHandoffTimeoutId);
      }
    };
  }, [chatHandoffFlow?.status]);

  const handleFailureHotHandoff = async () => {
    if (
      !isMentorSide &&
      chatHandoffFlow?.status ===
        VIDABOO_CONSTANTS.CHAT_HANDOFF_FLOW_STATUS.HOT_HANDOFF_IN_PROGRESS
    ) {
      const hotHandoffWaitTimeSeconds =
        chatHandoffFlow?.hotHandoffWaitTimeSeconds ??
        VIDABOO_CONSTANTS.HOT_HANDOFF_WAIT_TIME_SECONDS;
      const createdTime = moment(chatHandoffFlow.updatedTime);
      const currentTime = moment();
      const elapsedTimeSinceFlowCreatedSeconds = currentTime.diff(
        createdTime,
        'seconds',
      );

      if (elapsedTimeSinceFlowCreatedSeconds >= hotHandoffWaitTimeSeconds) {
        await chatHandoffService.failureHotHandoff(
          senderObjectType,
          senderObjectId,
          chatHandoffFlow.chatHandoffFlowId,
        );
      } else {
        const remainingHotHandoffTimeMs =
          (hotHandoffWaitTimeSeconds - elapsedTimeSinceFlowCreatedSeconds) *
          1000;
        const timeoutId = setTimeout(async () => {
          await chatHandoffService.failureHotHandoff(
            senderObjectType,
            senderObjectId,
            chatHandoffFlow.chatHandoffFlowId,
          );
        }, remainingHotHandoffTimeMs);
        setHotHandoffTimeoutId(timeoutId);
      }
    }
  };

  const getShouldListenToHandoffFlowChanges = (chatHandoffFlow) => {
    return (
      chatHandoffFlow?.chatHandoffFlowId &&
      ![
        VIDABOO_CONSTANTS.CHAT_HANDOFF_FLOW_STATUS.HOT_HANDOFF_SUCCEEDED,
        VIDABOO_CONSTANTS.CHAT_HANDOFF_FLOW_STATUS.HOT_HANDOFF_FAILED,
        VIDABOO_CONSTANTS.CHAT_HANDOFF_FLOW_STATUS.COLD_HANDOFF_DONE,
      ].includes(chatHandoffFlow.status)
    );
  };

  const getHandoffFlow = async () => {
    const chatHandoffFlowId = parsedMetaData.chatHandoffFlowId;
    const chatHandoffResponse =
      await chatHandoffService.getChatHandoffByChatHandoffFlowId(
        senderObjectType,
        senderObjectId,
        chatHandoffFlowId,
      );
    if (chatHandoffResponse.success && chatHandoffResponse.chatHandoffFlow) {
      setChatHandoffFlow(chatHandoffResponse.chatHandoffFlow);
    } else {
      setChatHandoffFlow(null);
    }
  };

  const convertHandoffActionsToBtnFormat = (selectedHandoffActions) => {
    return selectedHandoffActions
      ?.map((handoffAction) => HANDOFF_ACTIONS_BTN_INFO[handoffAction])
      ?.filter((actionBtn) => actionBtn !== undefined);
  };

  const handleTypingComplete = () => {
    setIsTypingComplete(true);
  };

  const onHandoffActionSelected = (handoffAction) => {
    let selectedWidgetAppType = null;
    switch (handoffAction) {
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.TEXT_CHAT:
        // selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT;
        break;
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.VIDEO_CALL:
        // selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL;
        break;
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.SCHEDULING:
        selectedWidgetAppType =
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING;
        break;
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.CONTACT_FORM:
        selectedWidgetAppType =
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR;
        break;
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.FB_MESSENGER:
        selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER;
        break;
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.WHATSAPP:
        selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP;
        break;
      case VIDABOO_CONSTANTS.HANDOFF_ACTIONS.PHONE:
        selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL;
        break;
      default:
        console.debug('Following handoff button is not handled', handoffAction);
    }
    if (!chatHandoffFlow?.selectedAction) {
      chatHandoffService.handoffSelectionFromCustomer(
        senderObjectType,
        senderObjectId,
        chatHandoffFlow.chatHandoffFlowId,
        handoffAction,
      );
    }
    if (selectedWidgetAppType) {
      onFooterOptionSelected(selectedWidgetAppType);
    }
  };

  return (
    <div
      className={`et-ai-chat-msg-content-wrapper-container ${!isMentorSide ? 'et-ai-chat-msg-content-wrapper-container-client' : ''} `}>
      <div className="et-acmcwc-ai-content-msg-time-wrap">
        <div
          className={`et-acmcwc-ai-bot-icon-name-msg-wrap ${isMentorSide ? 'et-acmcwc-ai-bot-icon-name-msg-wrap-color-border' : ''}`}>
          {isMentorSide && (
            <div className="et-acmcwc-abinmw-non-animated-border" />
          )}
          <div
            className={`${isMentorSide ? 'et-acmcwc-abinmw-wrap-non-animated' : 'et-acmcwc-abinmw-wrap'}`}>
            {!isMentorSide ? (
              <div className="et-acmcwc-ai-bot-wrap">
                <AiBotIcon />
              </div>
            ) : (
              <div className="et-acmcwc-ai-bot-wrap-mentor">
                <NotificationAiBotIcon />
              </div>
            )}

            <div className="et-acmcwc-ai-bot-name-msg-wrap">
              <div className="et-acmcwc-ai-bot-name">
                {utilsService.getAssistantName(
                  mentorDto?.appControlDto?.assistantName,
                )}
              </div>
              <AutoTextTyperComponent
                isAnimationDisable={!chatMessageDto.isMsgAddedOrUpdatedViaWs}
                text={chatMessageDto.messageText}
                getTextMessage={getTextMessage}
                onTypingComplete={handleTypingComplete}
              />
              {isTypingComplete && (
                <div className="et-ai-handoff-started-chat-msg-handoff-options-wrap">
                  {handoffActionsBtnInfo ? (
                    handoffActionsBtnInfo.map((handoffActionBtn, idx) => {
                      return (
                        <div
                          className="et-ai-ahscmc-handoff-option"
                          key={handoffActionBtn.id}
                          style={{'--animation-index': idx}}>
                          <ButtonComponent
                            isDisabled={
                              isDemo ||
                              isMentorSide ||
                              (chatHandoffFlow?.selectedAction &&
                                HOT_HANDOFF_ACTIONS_IDS.includes(
                                  handoffActionBtn.id,
                                ))
                            }
                            text={handoffActionBtn.text}
                            onClick={() => {
                              onHandoffActionSelected(handoffActionBtn.id);
                            }}
                            image={
                              <handoffActionBtn.Icon
                                fillColor={
                                  isMentorSide
                                    ? '#ffffff'
                                    : 'var(--et-mentor-cta-primary-btn-text-color)'
                                }
                                size={30}
                              />
                            }
                          />
                        </div>
                      );
                    })
                  ) : (
                    <ShimmerWithEmptyImageComponent
                      shimmerComponentType={
                        VIDABOO_CONSTANTS.SHIMMER_COMPONENT_TYPES
                          .AI_HANDOFF_ACTIONS
                      }
                    />
                  )}
                </div>
              )}
              {chatRowOptionsElement && (
                <div className="et-acmcwc-ai-msg-chat-row-options">
                  {chatRowOptionsElement}
                </div>
              )}
            </div>
          </div>
        </div>

        <p className="et-acmcwc-ai-msg-time" dir="auto">
          {chatMsgTime}
        </p>
      </div>
      {!isDemo &&
        !isMentorSide &&
        mentorDto?.appControlDto?.agentHandoffButton &&
        lastOoniChatMsg?.chatMessageId === chatMessageDto.chatMessageId && (
          <HandoffToAgentBtnComponent
            chatRoomDto={chatRoomDto}
            widgetId={widgetId}
          />
        )}
    </div>
  );
};

export default AiHandoffStartedChatMsgComponent;
